import { render } from "./FormBroadcastSetting.vue?vue&type=template&id=0e653d74&ts=true"
import script from "./FormBroadcastSetting.vue?vue&type=script&lang=ts"
export * from "./FormBroadcastSetting.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__